module.exports = __webpack_public_path__ + "static/media/game-cvinterviewericon16.a2e4aeac.png";